import React from 'react';

import GameBanner from '@molecules/GameBanner';
import links from '@constants/links';
import { IS_LG, IS_MD, IS_SM, IS_XL } from '@constants/platform';
import { Link } from '@react-navigation/native';

interface Props {
  dimensions: { width: string | number; height: string | number };
  isPrincipal?: boolean;
}

const GameBuilderBanner = ({ dimensions, isPrincipal }: Props) => {
  let image = links.gameBuilderMobileBanner;

  if (IS_SM) {
    image = links.gameBuilderTabletBanner;
  }

  if (IS_MD || IS_LG || IS_XL) {
    image = links.gameBuilderDesktopBanner;
  }

  const item = {
    id: 0,
    principalImage: links.gameBuilderMobileBanner,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    principalImage_web: image,
  };

  return <GameBanner item={item} dimentions={dimensions} ppal={isPrincipal} internalLink />;
};

export default GameBuilderBanner;
